// Libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  deleteTimeClock,
  getTimeClockDetails,
  getTimeClockHoursWorked,
  getTimeClockList,
} from '~/thunks/timeClock/timeClockThunk';
import { ITimeClockDetail } from '~/utils/interface/timeClock';

export interface ITimeClockState {
  isRefreshTimeClockList: boolean;
  timeClockDetails: ITimeClockDetail;
}

export const initialState: ITimeClockState = {
  isRefreshTimeClockList: false,
  timeClockDetails: {} as ITimeClockDetail,
};

const timeClockSlice = createSlice({
  name: 'timeClock',
  initialState,
  reducers: {
    setRefreshTimeClockList(state: ITimeClockState, action: PayloadAction<boolean>) {
      state.isRefreshTimeClockList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get time clock list
    builder
      .addCase(getTimeClockList.pending, (_state) => {})
      .addCase(getTimeClockList.fulfilled, (_state) => {})
      .addCase(getTimeClockList.rejected, (_state) => {});

    // DELETE: Delete time clock
    builder
      .addCase(deleteTimeClock.pending, (_state) => {})
      .addCase(deleteTimeClock.fulfilled, (_state) => {})
      .addCase(deleteTimeClock.rejected, (_state) => {});

    // GET: Get Time Clock Hours Worked
    builder
      .addCase(getTimeClockHoursWorked.pending, (_state) => {})
      .addCase(getTimeClockHoursWorked.fulfilled, (state, action) => {})
      .addCase(getTimeClockHoursWorked.rejected, (_state) => {});

    // GET: Get time clock details
    builder
      .addCase(getTimeClockDetails.pending, (_state) => {})
      .addCase(getTimeClockDetails.fulfilled, (state, action) => {
        state.timeClockDetails = action.payload.data;
      })
      .addCase(getTimeClockDetails.rejected, (_state) => {});
  },
});

// Action
export const timeClockActions = timeClockSlice.actions;

// Selectors
export const selectIsRefreshTimeClockList = (state: RootState) => state.timeClock.isRefreshTimeClockList;
export const selectTimeClockDetails = (state: RootState) => state.timeClock.timeClockDetails;

// Reducer
const timeClockReducer = timeClockSlice.reducer;
export default timeClockReducer;
